module.exports = __webpack_public_path__ + "static/media/white.437daa22.svg";